const swiperTimeline = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        import('swiper/bundle').then(({Swiper}) => {

            let domEls = document.querySelectorAll('.js-swiper-timeline');
            // let domElsPagination = document.querySelectorAll('.js-swiper-timeline-pagination');
            let domElsPagination;

            if (domEls) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                domEls.forEach(el => {

                    domElsPagination = el.nextElementSibling;

                    swiperTimeline.swiperInstancePagination = new Swiper(domElsPagination, paginationParams);   //NOSONAR
                    swiperTimeline.swiperInstance = new Swiper(el, params);   //NOSONAR

                    swiperTimeline.swiperInstance.controller.control = swiperTimeline.swiperInstancePagination
                    swiperTimeline.swiperInstancePagination.controller.control = swiperTimeline.swiperInstance
                })
            }
        })
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 500,
        a11y: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        on: {
            // since we want the previous years on the left, we start with the last slide
            init: function () {
                this.slideTo(this.slides.length - 1, 0, false);
            }
        }
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 32,
        slidesPerView: 1,
        speed: 500,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        autoHeight: true,
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        on: {
            // since we want the previous years on the left, we start with the last slide
            init: function () {
                this.slideTo(this.slides.length - 1, 0, false);
            }
        }
    }
}

export default swiperTimeline;